import { useRef, useState } from "react";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import SelectDropdown from "../SelectDropdown";
import { AttributeFieldProps } from "./RenderAttributeInput";
import LayoutNode, { AttributeCollection, getNodeStyleAttributeValue, setNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { NumInput } from "./GridAreaField";


const selectOptions = [
    {label:"Auto",value:""},
    {label:"Center",value:"50% 50%"},
    {label:"Left",value:"0% 50%"},
    {label:"Right",value:"100% 50%"},
    {label:"Top",value:"50% 0%"},
    {label:"Bottom",value:"50% 100%"},
    {label:"Custom",value:"custom"},
]

const GetSelection = (val:string):string=>{

    let selected = selectOptions.find((o)=>o.value == val);

    if(!selected&&!val.includes(" ")){
        selected = selectOptions.find((o)=>o.value.toLowerCase() == val);

    }

    if(selected){
        return selected.value;
    }
    return "custom";

}

const getXY = (node:AttributeCollection,screenSize:ScreenSize,attributeKey:string):{x:number,y:number}=>{
    let val = getNodeStyleAttributeValue(node,screenSize,attributeKey,"");
    let split = val.replaceAll("%","").split(" ");
    let x = 50;
    let y = 50;
    if(split.length == 2){
        x = parseFloat(split[0]);
        y = parseFloat(split[1]);
    }
    return {x,y};
}

export default function ImagePositionField({label,definition,layoutObject,updateFunc,saveFunc,siteData,screenSize}:AttributeFieldProps){

const [selectType,setSelectType] = useState<string>(GetSelection(getNodeStyleAttributeValue(layoutObject,screenSize,definition.attKey,"")));

const xy = useRef(getXY(layoutObject,screenSize,definition.attKey));



let startVal = getNodeStyleAttributeValue(layoutObject,screenSize,definition.attKey,"");


return(

    <div className="wb-input-group">
        <div className="flex-row justify-between">
            <label className={(startVal=="")?"not-updated":"updated"} >{label}</label>

        <SelectDropdown options={selectOptions} defaultValue={selectType} onChange={function (val: string): void {
            if(val !="custom"){
                updateFunc(definition.attKey,val,definition.targetType);
            }

            xy.current = getXY(layoutObject,screenSize,definition.attKey);
            setSelectType(val);
        } } />
</div>
        {selectType == "custom" && <div style={{marginTop:"8px"}} className="flex-row justify-center gap-large">
            <div className="flex-row gap-med">
                <label>X</label>
                <NumInput unitString="%" autoVal={50} min={0} max={100} inVlaue={xy.current.x.toString()} onUpdate={(num)=>{
                    xy.current.x = parseFloat(num);
                    updateFunc(definition.attKey,`${xy.current.x}% ${xy.current.y}%`,definition.targetType);

                 }} />
            </div>
            <div className="flex-row gap-med">
                <label>Y</label>
                <NumInput unitString="%" autoVal={50} min={0} max={100} inVlaue={xy.current.y.toString()} onUpdate={(num)=>{
                    xy.current.y = parseFloat(num);
                    updateFunc(definition.attKey,`${xy.current.x}% ${xy.current.y}%`,definition.targetType);

                 }} />
            </div>


            </div>

        }

    </div>

)
}
